import React, { PropTypes } from 'react'
import { connect } from 'react-redux';
import PreviousWebinarsView from 'components/Dashboard/PreviousWebinars/PreviousWebinars';
import PreviousWebinarItem from 'components/Dashboard/PreviousWebinars/PreviousWebinarItem';
import actions from 'actions';
import { push } from 'redux-router';
import constants from 'constants';
import storage from 'services/storage.js'

const {
  subscribeWebinarSaga,
} = actions;

const {
  PREVIOUS_WEBINARS
} = constants;

class PreviousWebinars extends React.Component {
  constructor(props) {
    super(props);
    this.token = storage.getSessionData().session.token;
  }

  webinars = () => (
    this.props.webinars.map(webinar => {
      return(
        <PreviousWebinarItem
          key={webinar.id}
          webinar={webinar}
          token={this.token}
          subscriptionAction={() => this.subscriptionAction(webinar)}
        />
      )
    })
  )

  subscriptionAction = (webinar) => {
    if (!webinar.subscription_id && webinar.webinar_type !== 'recorded')
      this.props.subscribeWebinar(webinar);
    this.props.showWebinar(webinar.id)
  }

  render() {
    return(
      <PreviousWebinarsView
        nextPage={this.props.nextPage}
        webinars={this.webinars()}
        pagination={this.props.pages > this.props.page}
        count={this.props.count}
        sponsor={this.props.sponsor}
        sponsors={this.props.sponsors}
        onFilterChange={this.props.onFilterChange}
      />
    )
  }
}

PreviousWebinars.propTypes = {
  webinars: PropTypes.array,
  subscribeWebinar: PropTypes.func,
}

const mapStateToProps = (state) => ({
  pages: state.webinars[PREVIOUS_WEBINARS].pages
})

const mapDispatchToProps = (dispatch) => ({
  subscribeWebinar: (webinar) => dispatch(subscribeWebinarSaga(webinar)),
  showWebinar: (id) => dispatch(push(`/webinars/${id}`))
});

export default connect(mapStateToProps, mapDispatchToProps)(PreviousWebinars);



/** WEBPACK FOOTER **
 ** ./src/containers/Dashboard/PreviousWebinars/PreviousWebinars.jsx
 **/